var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BCheckbox',{attrs:{"value":_vm.value,"native-value":_vm.subcategory.groupId},on:{"input":function($event){return _vm.$emit('input', $event)}}},[_vm._v(" "+_vm._s(_vm.getName(_vm.subcategory))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }